<app-navbar-style-two></app-navbar-style-two>

<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2 class="font-family005">Solutions</h2>
            <ul class="font-family005">
                <li><a routerLink="/"><i class="bx bx-home"></i> Home</a></li>
                <li class="active">Solutions / Web or Mobile Applications</li>
            </ul>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start Services Details Area -->
<section class="services-details-area pt-5 pb-70">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="services-details-content">
                    <h2 class="text-capitalize font-family005">Web / Mobile Applications</h2>
                    <div class="services-content">
                        <div class="services-details-one">
                            <div class="row match-height">
                                <div class="col-12 col-md-6">
                                    <img src="assets/img/product/web.jpeg" alt="Image" class="fix img-fluid">
                                </div>
                                <div class="col-12 col-md-6">
                                    <img src="assets/img/product/mobile.jpeg" alt="Image" class="fix img-fluid">
                                </div>
                            </div>
                        </div>
                        <p class="font-family004 pt-3">Bonton's SMART KAVALAN APP -The field policing application was developed for use by Tamil Nadu police with an objective to leverage technology to manage the beat activities digitally and make patrolling and field policing more efficient. They can get reports on data recorded during beat and other field activities. Station records such as “bad character” check list, lookout database and important locations can be tagged and stored on the app. The app will be available in English and Tamil. </p>
                    </div>

                    <div class="services-content">
                        <h3 class="font-family005">What is Web and Mobile app</h3>
                        <p class="font-family004">Mobile websites are compatible across all devices and can be accessed by anyone through a web browser, while apps require downloading and special adaptations for each operating system -- such as Android and iOS. Apps are not immediately accessible like a website until they are installed.
                        </p> 
                    </div>

                    <div class="services-content">
                        <h3 class="font-family005">Why is it important?</h3>
                        <p class="font-family004">A well-designed and useful app opens a world of opportunities because so much of our internet-based activity now occurs on the go. With customers utilizing their mobile devices whether on public transportation, when sitting in cafés, or simply walking down the street to stay connected.</p>
                        <p class="font-family004">Websites have now become an essential tool for any business that wants to grow and succeed in this modern age. Being at the forefront of technology is no longer necessary while building a website. How we all communicate with one another and how digital data is transported, shared, and received have undergone an intriguing change during the past ten years.
                        </p>    
                        <p class="font-family004">These software apps are designed to run on mobile devices,like smartphone or tablet computer.These applications can be pre-installed on phones during manufacturing platforms,or delivered as web applications using server-side or client-side processing to provide an "application-like" experience within a web browser.
                        </p>
                        <p class="font-family004">Mobile development refers to the building of apps, but also the building of websites perfectly suited for small devices like tablets and mobile phones. Responsive design is what makes websites fit to mobile device screens flawlessly, meaning users aren't slowed down by basic issues like formatting.
                        </p>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="services-sidebar">
                    <div class="services-category">
                        <ul class="font-family004">
                            <li><a routerLink="/smart-card">Smart Card Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/smart-city">Smart City and Safe City <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/vr-ar">VR / AR <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/enterprise-soln">Enterprise Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/marketing-soln">Marketing Solutions <i class="bx bx-chevron-right"></i></a></li>
                            <li><a routerLink="/web-app">Web / Mobile App <i class="bx bx-chevron-right"></i></a></li>
                            <!-- <li><a routerLink="/services-details">Penetration Testing <i class="bx bx-chevron-right"></i></a></li> -->
                        </ul>
                    </div>

                    <div class="services-pdf">
                        <ul class="font-family005">
                            <li><a href="assets/img/BT-CP.pdf"><i class="bx bxs-file-pdf"></i> Company Profile</a></li>
                            <!-- <li><a routerLink="/"><i class="bx bxs-file-doc"></i> DOC Download</a></li> -->
                        </ul>
                    </div>

                    <div class="services-contact mb-30">
                        <h3 class="font-family003">Contact us to do your new projects</h3>
                        <a routerLink="/contact" class="default-btn font-family005"><span>Contact Us</span></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- End Services Details Area -->

